import React from 'react';
import moment from 'moment';

export default [
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
    render: branchName => (Boolean(branchName?.length) && branchName !== '-' ? branchName : 'N/A'),
    sorter: true
  },
  {
    title: 'Instructor',
    dataIndex: 'instructor',
    key: 'instructor',
    render: (body, row) => {
      return (row.instructor || '').length ? row.instructor : 'N/A';
    },
    sorter: true
  },
  {
    title: 'Student',
    dataIndex: 'student',
    key: 'student',
    render: (body, row) => {
      return (row.student || '').length && row.student !== '-' ? row.student : 'N/A';
    },
    sorter: true
  },
  {
    title: 'Action ',
    dataIndex: 'action',
    key: 'action',
    render: (body, row) => {
      return <div style={{ wordBreak: 'break-word', whiteSpace: 'wrap' }}>{row.action}</div>;
    },
    sorter: true
  },
  {
    title: 'Action Description',
    dataIndex: 'action_description',
    key: 'action_description',
    render: (body, row) => {
      return (
        <div style={{ wordBreak: 'break-word', whiteSpace: 'wrap' }}>{row.actionDescription}</div>
      );
    },
    sorter: true
  },
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    key: 'timestamp',
    render: timestamp => moment(timestamp).format('MM/DD/YYYY HH:mm'),
    sorter: true
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    render: (body, row) => {
      return <div style={{ wordBreak: 'break-word', whiteSpace: 'wrap' }}>{row.note}</div>;
    }
  }
];
